import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  // Map input types to appropriate inputMode for mobile keyboards
  const getInputMode = (inputType?: string): React.ComponentProps<"input">["inputMode"] => {
    switch (inputType) {
      case "email":
        return "email"
      case "tel":
        return "tel"
      case "url":
        return "url"
      case "number":
        return "numeric"
      default:
        return undefined
    }
  }

  const inputMode = props.inputMode || getInputMode(type)

  return (
    <input
      type={type}
      inputMode={inputMode}
      data-slot="input"
      className={cn(
        "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex min-h-[44px] w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  )
}

export { Input }
